import { useActiveVersionNumber } from "@/lib/hooks/useActiveVersionNumber";
import { useVersionInformationSpec } from "@/lib/hooks/useVersionInformation";
import { BrainIcon } from "lucide-react";
import { useLayoutEffect, useRef } from "react";
import { useStickToBottom } from "use-stick-to-bottom";
import { MarkdownAttachmentView } from "../../AttachmentId";

export function SpecViewer() {
  const versionNumber = useActiveVersionNumber();
  const spec = useVersionInformationSpec(versionNumber);

  const isProcessing = spec?.status === "processing";
  const { scrollRef, contentRef, scrollToBottom } = useStickToBottom({
    initial: isProcessing && "instant",
  });

  const processingRef = useRef(isProcessing);

  useLayoutEffect(() => {
    const processingChanged = processingRef.current !== isProcessing;
    processingRef.current = isProcessing;
    if (isProcessing || processingChanged) {
      scrollToBottom("instant");
    }
  }, [isProcessing, scrollToBottom]);

  if (!spec) {
    return (
      <div className="h-full flex flex-col overflow-y-auto bg-background">
        <div className="h-full flex items-center justify-center">
          <div className="text-center">
            <div className="text-muted-foreground flex gap-2 items-center">
              <BrainIcon />
              No spec available for this version
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full overflow-y-auto bg-background" ref={scrollRef}>
      <div className="flex flex-col" ref={contentRef}>
        <MarkdownAttachmentView key={spec.id} attachment={spec} />
      </div>
    </div>
  );
}
